import ModalConfirm from '@/components/ModalConfirm/ModalConfirm'

interface ExportConfirmModalProps {
  open: boolean
  onClose: () => void
  onConfirm: () => void
  title: string
  loading?: boolean
  error?: string | null
}

export function ExportConfirmModal({
  open,
  onClose,
  onConfirm,
  title,
  loading = false,
  error = null,
}: ExportConfirmModalProps) {
  return (
    <ModalConfirm
      onOK={onConfirm}
      onCancel={onClose}
      confirmButtonText="Send Export"
      cancelButtonText="Cancel"
      title={title}
      type="export"
      loading={loading}
      content={
        <div>
          <div>
            An <strong>export file</strong> will be sent to your email address{' '}
            <strong>once the export is ready</strong>. You can continue working
            while the export is processed.
          </div>
          {error && (
            <div
              style={{
                color: '#C03261',
                marginTop: 10,
                fontWeight: 500,
              }}
            >
              {error}
            </div>
          )}
        </div>
      }
      open={open}
      onClose={onClose}
    />
  )
}
